import { defineStore } from "pinia";
import { ref } from "vue";
import { VoltCreatePaymentResponse } from "@/helpers/interfaces/providers";

/**
 * Volt store to manage Volt payment-related data such as payment information.
 * The store persists data in sessionStorage to maintain state across page
 * reloads within the same session.
 */
export const useVoltStore = defineStore(
    "volt",
    () => {
        // ── State ──────────────────────────────────────────────────────────────
        const voltPaymentInformation = ref<VoltCreatePaymentResponse | null>(
            null,
        );

        // ── Actions ────────────────────────────────────────────────────────────
        function setVoltPaymentInformation(
            information: VoltCreatePaymentResponse | null,
        ) {
            voltPaymentInformation.value = information;
        }

        return {
            voltPaymentInformation,
            setVoltPaymentInformation,
        };
    },
    {
        persist: {
            pick: ["voltPaymentInformation"],
            storage: sessionStorage,
        },
    },
);
